import * as React from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { SystemConfigType } from '../../../types/administrationTypes';

interface SystemsConfigurationProps {
  systemsList: SystemConfigType[];
  setSystemsList: React.Dispatch<React.SetStateAction<SystemConfigType[]>>;
}

const SystemsConfiguration: React.FC<SystemsConfigurationProps> = ({ systemsList, setSystemsList }) => {
  const intl = useIntl();

  return (
    <div className="tff-administration-flex-column">
      <Typography variant="h6" color="primary">
        <strong>{intl.formatMessage({ id: 'administration.systems' })}</strong>
      </Typography>
      {systemsList.map((system: SystemConfigType, index: number) => {
        const handleSystemChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const newState = systemsList.map(item =>
            item.value === system.value ? { ...item, selected: event.target.checked } : item,
          );
          setSystemsList(newState);
        };
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={system.selected}
                onChange={handleSystemChange}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                name={system.name}
              />
            }
            label={system.name}
            key={index}
            className="tff-administration-form-label-width"
          />
        );
      })}
    </div>
  );
};

export default SystemsConfiguration;
